module.exports = __webpack_public_path__ + "img/avterracebox27.a4f1e6e6.jpg";